import React, { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { QrCode } from "lucide-react";

// Prints a scan label: QR (encodes the raw code) + human-readable code + title/subtitle.
export function QrLabelButton({ code, title = "", subtitle = "", testid = "fx-print-label", label = "Print label" }) {
  const ref = useRef(null);
  const print = () => {
    const canvas = ref.current?.querySelector("canvas");
    const dataUrl = canvas ? canvas.toDataURL("image/png") : "";
    const w = window.open("", "_blank", "width=420,height=600");
    if (!w) return;
    w.document.write(`<!doctype html><html><head><title>${code}</title>
      <style>
        body{font-family:'Outfit',Helvetica,Arial,sans-serif;text-align:center;padding:28px;color:#0D530E}
        .brand{font-size:13px;letter-spacing:.25em;text-transform:uppercase;color:#306D29;margin-bottom:14px}
        img{width:260px;height:260px}
        .code{font-size:22px;font-weight:700;margin:14px 0 4px}
        .t{color:#333;font-size:15px;margin:2px}
        .s{color:#777;font-size:13px;margin:2px}
        @media print{@page{margin:8mm}}
      </style></head>
      <body>
        <div class="brand">AfriGate</div>
        <img src="${dataUrl}"/>
        <div class="code">${code}</div>
        ${title ? `<div class="t">${title}</div>` : ""}
        ${subtitle ? `<div class="s">${subtitle}</div>` : ""}
        <script>window.onload=function(){setTimeout(function(){window.print();},150);}<\/script>
      </body></html>`);
    w.document.close();
  };
  return (
    <>
      <div ref={ref} style={{ position: "absolute", left: -9999, top: -9999 }} aria-hidden>
        <QRCodeCanvas value={code} size={260} level="M" includeMargin />
      </div>
      <button onClick={print} data-testid={testid}
        className="inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-full bg-white border border-black/10 text-[#306D29] hover:border-[#306D29]/40">
        <QrCode size={14} /> {label}
      </button>
    </>
  );
}
